import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import NodeBackground from './NodeBackground';
import logo from './logo.png';
import './index.css';
import DropdownCards from './dropdown';
import Hiw from './hiw';
import Nav from './nav';
import About from './about_us';
import Features from './features';

function Home() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div className="page-root">
      <NodeBackground/>

      <div className="site-overlay">
        <Nav isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} logo={logo} />

        <header className="hero">
          <h1>
            Intuition as Intelligence — <br />
            <span>Reliable, Traceable, Actionable.</span>
          </h1>
          <p>Structuring Tacit Knowledge for a New Paradigm in Intelligence – Starting with Finance</p>
          <div className="hero-btns">
            <a className="btn-p" href="mailto:stephen@kerriganml.com?subject=Kerrigan%20Early%20Access">Get Early Access</a>
            <a className="btn-s" href="https://youtu.be/jNaEkq4CIn4" target="_blank" rel="noreferrer">Watch Demo</a>
          </div>
        </header>
      </div>

      <section className="home-faq-section">
        <DropdownCards />
      </section>

      <footer className="app-footer">
        <p>
          © 2026 Kerrigan. All rights reserved.
        </p>
      </footer>
    </div>
  );
}

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/hiw" element={<Hiw />} />
        <Route path="/about_us" element={<About />} />
        <Route path="/features" element={<Features />} />
      </Routes>
    </Router>
  );
}
